import MediaCard from "@/components/MediaTextCard.vue";
import { mediaInit } from "./Media";
import { builderCta } from "@/helpers/builder-init/index";
export const mediaCardInit = {
    component: MediaCard,
    name: "Media Card",
    inputs: [
        {
            name: "mediaProps",
            friendlyName: "Media Properties",
            type: "object",
            subFields: [...mediaInit.inputs]
        },
        {
            name: "title",
            friendlyName: "Title",
            type: "string",
            defaultValue: "Title"
        },
        {
            name: "description",
            friendlyName: "Body",
            type: "richText",
            defaultValue: "Body"
        },
        {
            name: "cta",
            friendlyName: "CTA",
            type: "object",
            defaultValue: builderCta.defaultValue,
            subFields: [...builderCta.subFields]
        }
    ]
};
